/* @jsx jsx */
import { css, jsx } from '@emotion/react';
import { TypeRamp, sizes, Link, colors } from '@smartsheet/lodestar-core';
import { ExternalIcon } from '@smartsheet/lodestar-icons';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface DisplayParentWorkflowsProps {
  parentWorkflows: string[];
}

const containerStyle = css`
  margin-top: ${sizes.large}px;
`;

const titleStyle = css`
  margin-bottom: ${sizes.small}px;
`;

const pWorkflowNameStyle = css`
  vertical-align: middle;
  margin-right: ${sizes.xSmall}px;
`;

const pWorkflowLinkIconStyle = css`
  vertical-align: middle;
`;

const pWorkflowsContainerStyle = css``;

const getBorderRadiusPX = (index: number, parentWorkflowsCount: number) => {
  switch (true) {
    case index === 0 && parentWorkflowsCount === 1:
      return '4px';
    case index === 0:
      return '4px 4px 0px 0px';
    case index === parentWorkflowsCount - 1:
      return '0px 0px 4px 4px';
    default:
      return '0px';
  }
};

const pWorkflowLinkStyle = (index: number, parentWorkflowsCount: number) => css`
  && {
    padding: ${sizes.small - 2}px ${sizes.medium}px;
    font-size: 13px;
    font-weight: 400;
    width: 100%;
    text-align: left;
    border-radius: ${getBorderRadiusPX(index, parentWorkflowsCount)};
    background: ${colors.buttonDefault};
  }
  :hover {
    background: ${colors.buttonDefaultHover};
  }
  :focus {
    background: ${colors.buttonDefaultFocus};
  }
  :active {
    background: ${colors.buttonDefaultPressed};
  }
`;

export const DisplayParentWorkflows = ({
  parentWorkflows,
}: DisplayParentWorkflowsProps) => {
  const { t: translate } = useTranslation();

  const getWorkflowElements = () => {
    return parentWorkflows.map((parentWorkflowName, index) => {
      return (
        <Link
          key={index}
          href={`/designer/${parentWorkflowName}`}
          target={'_blank'}
          rel={'noreferrer'}
          css={pWorkflowLinkStyle(index, parentWorkflows.length)}
        >
          <span css={pWorkflowNameStyle}>{parentWorkflowName}</span>
          <ExternalIcon css={pWorkflowLinkIconStyle} />
        </Link>
      );
    });
  };
  return (
    <div css={containerStyle}>
      <TypeRamp variant="metadata" css={titleStyle} renderAs="div">
        {translate('designer:triggerPanel:parentWorkflow:title')}
      </TypeRamp>
      <div css={pWorkflowsContainerStyle}>{getWorkflowElements()}</div>
    </div>
  );
};
